import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoteCard = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fff;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
`;

export const NoteCardTitle = styled.p`
  font-weight: bold;
  margin-bottom: 6px;
`;

export const NoteCardContent = styled.p`
  color: #333;
  font-size: 14px;
`;

export const Field = styled.div`
  margin: 8px 0;
  font-size: 14px;
  width: 100%;
  max-width: 600px;
  text-align: left;
  line-height: 1.5;

  strong {
    font-weight: 600;
    display: inline-block;
    min-width: 90px;
  }
`;
